


		/* START DYNAMICALLY GENERATED CODE BLOCK */
		var modulus = "D4229AD35AE3FE60E192948079DFEE523E018CE5931E6FF68A70C20A2A91D80FF09604DE9F4100C5B91A8433712428B35F3CC6C4CA814715BE470D811E73BE497788CA38494CADAF4825E78A508FAB023F65FC4722306FE7ECF1AC41C19AE5C4EFD3ACFE99EE08B60794EC19D57EA0E3556EE53F8DAECAB67DB47AFBC0F856AD";
		var e = "010001";
		
		/* END DYNAMICALLY GENERATED CODE BLOCK */

		var getpassword = function getpassword() {
            var cnum  = arguments[0];
	        var cpin  = arguments[1];
            var hdnrn = arguments[2];
            var hdnr  = arguments[3];
			if(arguments.length  > 4 && arguments[4]){
                modulus = arguments[4];
                e = arguments[5];
            }

			var nonce = hdnrn.value;
            						
			var rsa = new RSAKey();
			rsa.setPublic(modulus, e);
            
			var res = rsa.encrypt(cpin.value + "|" + nonce);
			if(res) {
				/* fill and submit hidden form */
			    var _hdnr = hdnr;
				_hdnr.value = res;
				
				//cpin.value = "";
			}
		}
		
		window.getpassword = getpassword;
